import {Signal, View} from "@lernetz/ts-lib";
import template from "./overlay.component.html"

export class Overlay extends View {
    constructor() {
        super({ template, data: new OverlayController()});
    }
    init() {
        this.node.addEventListener( 'click', ( event ) => {
            event.stopImmediatePropagation();
            this.data.signal.dispatch(event);
        });
    }
}

export class OverlayController {
    signal: Signal<unknown>;
    constructor() {
        this.signal = new Signal();
    }
}
